import React from "react";
import img1 from "../../assets/img/SF23.jpg";
// Assuming you might have a basic CSS file, e.g., Silverfort.css
import "./Silverfort.css"; 

export const Main = () => {
  return (
    <section className="sf-container">
      <div className="sf-image-wrapper">
        {/* Crucial: Add meaningful alt text for accessibility */}
        <img src={img1} alt="Silverfort Identity Protection Platform illustration" />
      </div>
      <div className="sf-content">
        {/* Add a heading to give context */}
        <h2>Unified Identity Protection</h2>
        
        {/* Break text into smaller, digestible paragraphs */}
        <p className="sf-lead">
          Silverfort extends <strong>Multi-Factor Authentication (MFA)</strong> and <strong>Zero Trust</strong> access to any resource.
        </p>
        <p>
          This includes resources that are traditionally hard to protect, such as legacy systems, command-line tools, and service accounts.
        </p>
        <p>
          It helps prevent identity-based attacks by enforcing adaptive access policies across both cloud and on-premises environments—<strong>without requiring agents or proxies</strong>.
        </p>
      </div>
    </section>
  );
};